import { clearFilterParams, useCleanFilterForRequest } from '@btime/react-contexts'
import { gql } from '@apollo/client'
import { path } from 'ramda'
import React from 'react'

import { placesClient } from '../../utils/apollo/api'
import { usePromiseQuery } from '../../utils/apollo/_helpers/promiseQuery'
import LazySelectAllLinkApollo from '../../components/actions/LazySelectAllLinkApollo'

const QUERY = gql`
  query Assets($search: String, $filter: AssetFilter) {
    assets(limit: 900000, search: $search, filter: $filter) {
      id
    }
  }
`

export const useGetAllAssets = () => {
  const filter = useCleanFilterForRequest()
  const call = usePromiseQuery(QUERY, {
    variables: { filter },
    client: placesClient
  })
  return () => call().then(path(['data', 'assets']))
}

const SelectAllAssetsLink = ({ search, filter, ...props }) => {
  return (
    <LazySelectAllLinkApollo
      query={QUERY}
      variables={{ search, filter: clearFilterParams(filter || {}) }}
      client={placesClient}
      {...props}
    />
  )
}

export default SelectAllAssetsLink
